export enum Speed {
  SLOW = 'SLOW',
  DEFAULT = 'DEFAULT',
  FAST = 'FAST',
}
